import {ICatalogo} from "../../entities/catalogos/ICatalogo";

export const LOAD_PAISES_SUCCESS = 'LOAD_PAISES_SUCCESS';


interface ILoadPaises {
    type: typeof LOAD_PAISES_SUCCESS
    paises: ICatalogo[]
}

export type PaisActionTypes = ILoadPaises
